import type { FC } from 'react';

import { useCoreDispatch } from '../../../../store/CoreStore';
import { useChatSlice } from '../../../../store/slices/chat/selectors';
import { chatActions } from '../../../../store/slices/chat/slice';
import { ChatTabType } from '../../../../store/slices/chat/types';

import { ChatTabs } from './ChatTabs';

export const ChatTabsConnected: FC = () => {
  const selectedTab = useChatSlice.getSelectedTab();
  const isLiveSupportRead = useChatSlice.getIsLiveSupportRead();
  const dispatch = useCoreDispatch();

  const handleTabSelect = (tab: ChatTabType): { payload: ChatTabType; type: 'chat/setSelectedTab' } => {
    return tab === ChatTabType.GameChat
      ? dispatch(chatActions.setSelectedTab(ChatTabType.GameChat))
      : dispatch(chatActions.setSelectedTab(ChatTabType.LiveSupportChat));
  };

  return <ChatTabs isLiveSupportRead={isLiveSupportRead} onTabSelect={handleTabSelect} selectedTab={selectedTab} />;
};
